<template>
    <fragment>
        <help-modal/>

        <div class="modal inmodal fade" id="add-new-payment-type-modal" tabindex="-1" role="dialog" aria-hidden="true">
            <div class="modal-dialog">
                <div class="modal-content">
                    <div class="modal-header">
                        <button type="button" class="close" data-dismiss="modal"><span aria-hidden="true">&times;</span><span class="sr-only">{{__("close")}}</span></button>
                        <h3>{{__("add_new_payment_type")}}
                            <button-open-help-modal :help-name="'UUH-005'" :inExtraDiv="false"/>
                        </h3>
                     </div>
                        <div class="modal-body">
                            <div class="row">
                                <div class="col-12">
                                  <form id="new-payment-form" :action=route method="POST">
                                    <input id="modal-create-csrf-token" type="hidden" name="_token" value="">
                                    <input type="hidden" name="default_language_name" :value="defaultLanguage">
                                        <label><strong>{{__("payment_type_name")}}</strong></label>
                                            <div class="input-group m-b-xs">
                                                <select class="form-control disabled-select" style="max-width:60px" disabled>
                                                    <option :value=defaultLanguage selected>{{defaultLanguage.toUpperCase()}}</option>
                                                </select>
                                                <input type="text" max="30" v-model="nameForDefaultLanguage" required name="name_in_default_language" class="form-control">
                                            </div>
                                        <div v-for="translationNumber  in addedTranslationsNumber" :key="translationNumber" class="input-group m-b-xs">
                                            <select v-model="currentlyChosenLanguageForTranslationNumber[translationNumber]" class="form-control disabled-select available-translations-list" name="language[]" style="max-width:60px;" >
                                                <option v-for="(language,index) in languagesAvailableForTranslationNumber[translationNumber]" :key="language" :value="language">{{language.toUpperCase()}}</option>
                                            </select>
                                            <input type="text" max="30" name="translation[]" class="form-control">
                                        </div>
                                        <button type="button" v-on:click="addTranslation"  class="btn btn-primary add-translation-button">{{__("add_new_translation")}}</button>
                                    </form>
                                </div>
                            </div>
                        </div>

                        <div class="modal-footer">
                            <button type="button" class="btn btn-white" data-dismiss="modal">{{__("cancel")}}</button>
                            <button type="submit" form="new-payment-form"  class="btn btn-primary">{{__("save")}}</button>
                        </div>
                </div>
            </div>
        </div>

    </fragment>

</template>

<script>

import { Fragment } from 'vue-fragment';
import HelpModal from './help/HelpModal.vue'
import ButtonOpenHelpModal from './help/ButtonOpenHelpModal.vue';

export default {
        name: 'modal-create-new-payment-type',
        props: ['defaultLanguage', 'languagesExceptDefault', 'route'],
        components : { Fragment, HelpModal, ButtonOpenHelpModal },
        data: function() {
            return {
              availableLanguages : null,
              addedTranslationsNumber : 0,
              languagesAvailableForTranslationNumber : [],
              currentlyChosenLanguageForTranslationNumber : [],
              nameForDefaultLanguage : ""
            };
        },

        methods: {
            addTranslation()
            {
                if(this.addedTranslationsNumber <= this.availableLanguages.length)
                {
                   const lastChosenLanguage = this.currentlyChosenLanguageForTranslationNumber[this.addedTranslationsNumber];
                   this.availableLanguages = this.availableLanguages.filter(function(value){
                        return value != lastChosenLanguage;
                   });

                   this.languagesAvailableForTranslationNumber[this.addedTranslationsNumber] = [lastChosenLanguage];
                   this.languagesAvailableForTranslationNumber[this.addedTranslationsNumber + 1] = this.availableLanguages;
                   this.currentlyChosenLanguageForTranslationNumber[this.addedTranslationsNumber + 1] = this.availableLanguages[0];
                   ++this.addedTranslationsNumber;
                }
            }

        },

        mounted: function() {
           const csrfTokenValue = $('meta[name="csrf-token"]').attr('content');
           $("#modal-create-csrf-token").val(csrfTokenValue);
        },

        events: {
            resetModalCreate() {
                this.availableLanguages = JSON.parse(this.languagesExceptDefault)
                this.addedTranslationsNumber = 0;
                this.languagesAvailableForTranslationNumber = [];
                this.currentlyChosenLanguageForTranslationNumber = [];
                this.nameForDefaultLanguage = "";
            }
        }
    }
</script>
